import { useMemo } from "react";
import { Button, Loader, Modal } from "../../../components/ui";
import { strings } from "../../../strings/strings";
import { useAppQuery } from "../../../api/fetchClient";
import { VIEW_HOSPITAL } from "../../../api/url";
import { QUERY_KEYS } from "../../../api/queryKeys";

const ViewHospitalModal = ({ isOpen, onClose, hospital }) => {
  const hospitalId = hospital?.id || hospital?._id;

  const { data, isLoading } = useAppQuery({
    queryKey: [QUERY_KEYS.HOSPITAL_DETAILS, hospitalId],
    url: VIEW_HOSPITAL,
    method: "GET",
    params: { hospitalId },
    enabled: !!hospitalId && isOpen,
  });

  const hospitalData = useMemo(() => {
    return data?.results?.hospital;
  }, [data]);

  const footer = (
    <div className="flex justify-end">
      <Button variant="outline" onClick={onClose}>
        {strings.close }
      </Button>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={strings.viewHospital} size="lg" footer={footer}>
      {isLoading ? (
        <div className="flex justify-center items-center py-24">
          <Loader />
        </div>
      ) : (
        <div className="space-y-6">
          <div className="border rounded-xl p-5 bg-white shadow-sm ">
            <h3 className="text-lg font-medium text-secondary">
              {strings.hospitalName} :
              <span className="text-lg ml-2 font-semibold text-secondary">{hospitalData?.name || "-"}</span>
            </h3>
            <p className="text-sm font-semibold text-secondary mt-1">
              {strings.refferalCode}:{" "}
              <span className="text-sm font-bold text-secondary mt-1">{hospitalData?.referral_code || "-"}</span>
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InfoBlock label={strings.city} value={hospitalData?.city} />
            <InfoBlock label={strings.state} value={hospitalData?.state} />

            <div className="md:col-span-2">
              <InfoBlock label={strings.address} value={hospitalData?.address} />
            </div>
            <InfoBlock label={strings.country} value={hospitalData?.country} />
          </div>
        </div>
      )}
    </Modal>
  );
};

const InfoBlock = ({ label, value }) => (
  <div className="border rounded-xl p-4 bg-gray-50 hover:bg-gray-100 transition-colors">
    <p className="text-xs uppercase tracking-wide font-medium text-secondary">{label}</p>
    <p className="text-sm text-secondary font-medium mt-1 break-words">{value || "-"}</p>
  </div>
);

export default ViewHospitalModal;
